import type { ReactElement } from 'react';

interface SettingsToggleProps {
  readonly label: string;
  readonly checked: boolean;
  readonly disabled?: boolean;
  readonly disabledReason?: string | undefined;
  readonly testId?: string;
  readonly onChange: (checked: boolean) => void;
}

export function SettingsToggle({ label, checked, disabled, disabledReason, testId, onChange }: SettingsToggleProps): ReactElement {
  return (
    <label
      title={disabled ? disabledReason : undefined}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexShrink: 0, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1 }}
    >
      <input
        type="checkbox"
        aria-label={label}
        data-testid={testId}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        style={{ margin: 0, width: 16, height: 16, accentColor: 'var(--accent)' }}
      />
      <span style={{ fontSize: 12, fontWeight: 600, minWidth: 24, color: checked ? 'var(--accent)' : 'var(--text-muted)' }}>
        {checked ? 'On' : 'Off'}
      </span>
    </label>
  );
}
